import * as React from "react"

import { LoginInner } from "./LoginInner"

export default class Login extends React.Component {

    render() {

        return <LoginInner />
    }
}


// WEBPACK FOOTER //
// ./src/Routes/Login/Login.tsx